import React from "react";
import { Navigate } from "react-router-dom";
import { useModuleConfigContext } from "../contexts/ModuleConfigContext";
import { canAccessFeature, type ModuleName } from "../permissions/modulePermissions";

interface FeatureRouteGuardProps {
  module: ModuleName;
  feature?: string;
  children: React.ReactElement;
}

export const FeatureRouteGuard: React.FC<FeatureRouteGuardProps> = ({
  module,
  feature,
  children,
}) => {
  const { modules } = useModuleConfigContext();
  const allowed = canAccessFeature(modules, module, feature);

  if (!allowed) {
    return <Navigate to="/403" replace />;
  }

  return children;
};
